<script setup>
import ConnectorItem from '@/components/front/combination/ConnectorItem.vue';
import combinationStorage from '@/services/combination-storage';
import { computed, defineOptions, reactive, ref } from 'vue';
import CombinationService from '@/services/combination-service';

defineOptions({
  name: 'CombinationProductConnect'
});

const initialItem = combinationStorage.initialItem;
const terminalItem = combinationStorage.terminalItem;

const state = reactive({
  cables: combinationStorage.cables
})

for (let i = 1; i <= Object.values(combinationStorage.cables).length; i++) {
  combinationStorage.cables[i].isValid = true;

  const defaultCategory = state.cables[i].variant?.categories.find(function ($v) {
    return $v.options.non_contact === 0;
  })

  if (
    initialItem
    && state.cables[i]['initial'].category === null
    && defaultCategory
  ) {
    state.cables[i]['initial'].category = defaultCategory;
  }

  if (
    terminalItem
    && state.cables[i]['terminal'].category === null
    && state.cables[i]['terminal'].pin !== null
    && defaultCategory
  ) {
    state.cables[i]['terminal'].category = defaultCategory;
  }
}

function setCableCategory(type, key, category) {
  state.cables[key][type].category = category;
}

</script>

<template>
  <div class="l-product-cable">
    <section class="l-product-cable__order">
      <div class="container-fluid">
        <!--<div class="row mb-4 d-none d-xl-block" v-if="combinationStorage.initialItem && combinationStorage.terminalItem">-->
        <!--  <div class="col d-flex justify-content-center align-items-center gap-3">-->
        <!--    <span>將起始端</span>-->
        <!--    <span>第</span>-->
        <!--    <select class="l-product-cable__sync form-select fs-6">-->
        <!--      <option>1</option>-->
        <!--      <option>2</option>-->
        <!--      <option>3</option>-->
        <!--      <option>4</option>-->
        <!--    </select>-->
        <!--    <span>孔</span>-->
        <!--    <span>的串接方式套用至</span>-->
        <!--    <select class="l-product-cable__sync l-product-cable__sync&#45;&#45;port form-select fs-6">-->
        <!--      <option>起始端</option>-->
        <!--      <option>終端</option>-->
        <!--    </select>-->
        <!--    <button type="button" class="btn btn-dark">套用</button>-->
        <!--  </div>-->
        <!--</div>-->

        <div class="row mb-5"
          :class="!initialItem && !terminalItem ? 'justify-content-center' : ''"
        >
          <div class="col-6 col-xl-3 mb-4 mb-xl-0" v-if="initialItem">
            <p class="l-product-cable__thead mb-0 py-3 px-4 text-center">起始端</p>
            <ConnectorItem :item="initialItem"></ConnectorItem>
          </div>
          <div class="col-6 col-xl-3 mb-4 mb-xl-0 d-xl-none"
            v-if="terminalItem">
            <p class="l-product-cable__thead mb-0 py-3 px-4 text-center">終端</p>
            <ConnectorItem :item="terminalItem"></ConnectorItem>
          </div>

          <div class="col-12 col-xl-6">
            <p class="l-product-cable__thead mb-0 py-3 d-none d-md-flex">
              <span class="l-product-cable__thead--input px-4">起始端孔位</span>
              <span class="l-product-cable__thead--cable px-4">線材型號及長度</span>
              <span class="l-product-cable__thead--output px-4">終端孔位</span>
            </p>

            <ol class="l-product-cable__list mb-0 ps-0">
              <li v-for="(cable, i) in state.cables"
                class="l-product-cable__item l-product-connect__item py-md-4 d-flex align-items-md-center mb-4 mb-md-0"
                :class="!cable.isValid ? `invalid` : ''"
                :id="`product-cable-connect-` + i"
                :key="`cable-` + i">
                <p class="l-product-cable__item-thead mb-0 d-flex flex-column justify-content-between d-md-none">
                  <span class="l-product-connect__item-thead--input px-3 py-4">起始端孔位</span>
                  <span class="l-product-cable__item-thead--cable px-3">線材型號及長度</span>
                  <span class="l-product-connect__item-thead--output px-3 py-4">終端孔位</span>
                </p>

                <div
                  class="l-product-cable__item-wrapper d-flex justify-content-between align-items-md-center flex-column flex-md-row w-100">
                  <div class="l-product-connect__item--input d-flex flex-wrap align-content-center align-items-center ps-3"
                    >
                    <input v-if="combinationStorage.onlyCables || cable.allowNull" class="form-control" type="text"
                      value="無需插膠殼孔位" disabled readonly>

                    <div v-else class="mb-2">
                      <span>第</span>
                      <span class="text-dark">{{ cable.initial.pin }}</span>
                      <span>孔</span>
                    </div>

                    <div v-if="!cable.allowNull" class="dropdown l-product-cable__dropdown w-100">
                      <button class="btn c-choose-btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                        type="button" :id="`dropdown-` + i" data-bs-toggle="dropdown" aria-expanded="false"
                        :disabled="combinationStorage.flowIndex === 3"
                      >
                        <span>
                          {{ cable.initial.category?.title ? cable.initial.category.title : '串接方式' }}
                        </span>
                      </button>
                      <ul class="dropdown-menu" :aria-labelledby="`dropdown-` + i">
                        <li>
                          <a class="dropdown-item" href="javascript://"
                            :class="combinationStorage.onlyCables ? '' : `disabled`">
                            串接方式
                          </a>
                        </li>

                        <li v-for="(category, k) in cable.variant.categories">
                          <template v-if="cable.initial.pin">
                            <a v-if="!category.options.non_contact" class="dropdown-item" href="javascript://"
                              @click="setCableCategory('initial', i, category)"
                            >
                              {{ category.title }}
                            </a>
                          </template>
                          <template v-else>
                            <a v-if="category.options.non_contact" class="dropdown-item" href="javascript://"
                              @click="setCableCategory('initial', i, category)"
                            >
                              {{ category.title }}
                            </a>
                          </template>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="l-product-cable__item--cable px-3 px-md-4">
                    <div v-if="!cable.allowNull" class="l-product-cable__info d-flex justify-content-between align-items-center gap-2">
                      <div class="l-product-cable__info-wrapper">
                        <h2 class="h5 mb-0 fw-medium">
                          {{ cable.variant.product.title }}
                        </h2>
                        <div class="d-md-flex align-items-center gap-2 mb-1">
                          <p class="mb-0">
                            {{ cable.variant.product.model }}
                          </p>

                          <template v-if="cable.variant.sku">
                            <p class="mb-0">-</p>
                            <p class="mb-0">{{ cable.variant.sku }}</p>
                          </template>
                        </div>

                        <div v-if="!cable.variant.primary" class="c-port-card__specifications text-dark mb-0">
                          {{ CombinationService.getVariantTitleText(cable.variant.title) }}
                        </div>

                        <p>長度 <span class="text-dark">{{ cable.variant.length }}</span> 公分</p>
                      </div>
                    </div>

                    <div v-else class="text-center">-</div>
                  </div>

                  <div class="l-product-connect__item--output pe-3 d-flex flex-wrap align-content-center align-items-center">
                    <input class="form-control" type="text"
                      :value="cable.terminal.pin ? cable.terminal.pin :  '無需插膠殼孔位'" disabled readonly>

                    <div v-if="!cable.allowNull" class="dropdown l-product-cable__dropdown w-100">
                      <button class="btn c-choose-btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                        type="button" :id="`dropdown-` + i" data-bs-toggle="dropdown" aria-expanded="false"
                        :disabled="combinationStorage.flowIndex === 3"
                      >
                        <span>
                          {{ cable.terminal.category?.title ? cable.terminal.category.title : '串接方式' }}
                        </span>
                      </button>
                      <ul class="dropdown-menu" :aria-labelledby="`dropdown-` + i">
                        <li>
                          <a class="dropdown-item"
                            :class="cable.terminal.pin ? `disabled` : ''"
                            href="javascript://"
                            @click="setCableCategory('terminal', i, null)"
                          >
                            串接方式
                          </a>
                        </li>

                        <template v-for="(category, k) in cable.variant.categories">
                          <template v-if="cable.terminal.pin">
                            <li v-if="!category.options.non_contact" >
                              <a class="dropdown-item" href="javascript://"
                                @click="setCableCategory('terminal', i, category)"
                              >
                                {{ category.title }}
                              </a>
                            </li>
                          </template>

                          <template v-else>
                            <li v-if="category.options.non_contact" >
                              <a class="dropdown-item" href="javascript://"
                                @click="setCableCategory('terminal', i, category)"
                              >
                                {{ category.title }}
                              </a>
                            </li>
                          </template>
                        </template>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ol>
          </div>

          <div class="col-3 d-none d-xl-block" v-if="terminalItem">
            <p class="l-product-cable__thead mb-0 py-3 px-4 text-center">終端</p>
            <ConnectorItem :item="terminalItem"></ConnectorItem>
          </div>
        </div>
      </div>
    </section>

    <!--<div class="c-accordion accordion d-xl-none fixed-bottom" id="accordionSync"-->
    <!--  v-if="combinationStorage.initialItem && combinationStorage.terminalItem">-->
    <!--  <div class="accordion-item border-0">-->
    <!--    <h3 class="accordion-header">-->
    <!--      <button class="accordion-button collapsed h5 bg-white text-dark" type="button" data-bs-toggle="collapse"-->
    <!--        data-bs-target="#collapseOne"-->
    <!--        aria-expanded="true" aria-controls="collapseOne">-->
    <!--        套用串接方式-->
    <!--      </button>-->
    <!--    </h3>-->
    <!--    <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionSync">-->
    <!--      <div class="accordion-body">-->
    <!--        <div class="d-flex flex-wrap justify-content-center align-items-center gap-3">-->
    <!--          <span>將起始端</span>-->
    <!--          <span>第</span>-->
    <!--          <select class="l-product-cable__sync form-select fs-6">-->
    <!--            <option>1</option>-->
    <!--            <option>2</option>-->
    <!--            <option>3</option>-->
    <!--            <option>4</option>-->
    <!--          </select>-->
    <!--          <span>孔</span>-->
    <!--          <span>的串接方式套用至</span>-->
    <!--          <select class="l-product-cable__sync l-product-cable__sync&#45;&#45;port form-select fs-6">-->
    <!--            <option>起始端</option>-->
    <!--            <option>終端</option>-->
    <!--          </select>-->
    <!--          <button type="button" class="btn btn-dark">套用</button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
  </div>
</template>
